/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module for all things gslb related.
 * @preferred
 * @module GslbModule
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    gslbReplicationStatusOptions,
    gslbReplicationStatusPopoverOptions,
} from './components';

import {
    GslbGeoDbProfileCollection,
    GslbGeoDbProfileItem,
    GSLBService,
    GSLBServiceCollection,
    GSLBServiceFQDN,
    GSLBServiceFQDNCollection,
    GSLBServiceFQDNListCollDataSource,
    GSLBServiceFQDNListDataTransformer,
    GSLBSiteCollection,
    GSLBSiteInventoryCollDataSource,
    GSLBSiteInventoryDataTransformer,
} from '.';

import {
    GSLB_GEODB_PROFILE_COLLECTION_TOKEN,
    GSLB_GEODB_PROFILE_ITEM_TOKEN,
    GSLB_SERVICE_ITEM_TOKEN,
} from './gslb.tokens';

const gslbModule = angular.module('avi/gslb');

const factories = [
    {
        factory: GSLBService,
        name: GSLB_SERVICE_ITEM_TOKEN,
    },
    {
        factory: GSLBServiceCollection,
        name: 'GSLBServiceCollection',
    },
    {
        factory: GSLBServiceFQDN,
        name: 'GSLBServiceFQDN',
    },
    {
        factory: GSLBServiceFQDNCollection,
        name: 'GSLBServiceFQDNCollection',
    },
    {
        factory: GSLBServiceFQDNListCollDataSource,
        name: 'GSLBServiceFQDNListCollDataSource',
    },
    {
        factory: GSLBServiceFQDNListDataTransformer,
        name: 'GSLBServiceFQDNListDataTransformer',
    },
    {
        factory: GSLBSiteCollection,
        name: 'GSLBSiteCollection',
    },
    {
        factory: GSLBSiteInventoryCollDataSource,
        name: 'GSLBSiteInventoryCollDataSource',
    },
    {
        factory: GSLBSiteInventoryDataTransformer,
        name: 'GSLBSiteInventoryDataTransformer',
    },
    {
        factory: GslbGeoDbProfileItem,
        name: GSLB_GEODB_PROFILE_ITEM_TOKEN,
    },
    {
        factory: GslbGeoDbProfileCollection,
        name: GSLB_GEODB_PROFILE_COLLECTION_TOKEN,
    },
];

const components = [
    {
        name: 'gslbReplicationStatus',
        options: gslbReplicationStatusOptions,
    },
    {
        name: 'gslbReplicationStatusPopover',
        options: gslbReplicationStatusPopoverOptions,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(
        gslbModule,
        'factory',
        name,
        factory,
    );
});

components.forEach(({ name, options }) => gslbModule.component(name, options));
